<template>
    <div class="w100" style="background-repeat : no-repeat;background-size: 100%">

        <div class="file-content"  v-loading="loading">
            <div class="area-title">文件预览</div>
            <div  class="area card-shadow" >
                <div
                        class="form"
                        id="form"
                        v-if="fileSuffix&&fileTypeList.indexOf(fileSuffix) < 0"
                >
                    <div id="iframeEditor"></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import { previewFilesHttp} from "@/api/file/files";
    export default {
        name: "previewFilePage",
        components: {},
        data() {
            return {
                baseUrl: process.env.BASE_URL,
                loading:false,
                configData:{},
                fileTypeList: ["html","png","gif","jpg"],
                fileUrl:"",
                fileSuffix:"",

            };
        },
        computed: {},
        mounted() {
            this.setfileUrlAndSuffix();
            this.fileConfigFn();
        },

        methods: {
            setfileUrlAndSuffix(){
                this.fileUrl= this.$route.query.fileUrl;
                let index = (this.$route.query.fileUrl).lastIndexOf(".");
                this.fileSuffix = (this.$route.query.fileUrl).substr(index+1);
            },
            fileConfigFn() {
                this.loading = true;
                if (this.fileTypeList.indexOf(this.fileSuffix) < 0) {
                    previewFilesHttp(this.fileUrl)
                        .then(({data}) => {

                            if (data.code == 0) {
                                this.configData = data.data.params;
                                this.appendScript();
                            } else {
                                this.loading = false;
                                this.$notify.error({
                                    title: "错误",
                                    message: `预览出错,请稍后重试,${data.msg}`
                                });
                            }
                        }).catch(error => {
                        this.loading = false;
                            this.$notify.error({
                                title: "错误",
                                message: `预览出错,请稍后重试,${error.msg}`
                            });
                        });
                }else{
                    window.location.href=this.fileUrl;

                }
            },
            appendScript() {
                let al = document.getElementsByTagName("script");
                let scriptSrc = [];
                for (let i = 0; i < al.length; i++) {
                    scriptSrc.push(al[i].getAttribute("src"));
                }
                if (scriptSrc.indexOf(this.configData.api) < 0) {
                    let script = document.createElement("script");
                    script.type = "text/javascript";
                    script.src = this.configData.api;
                    document.getElementsByTagName("head")[0].appendChild(script);
                    script.onload = script.onreadystatechange = () => {
                        new DocsAPI.DocEditor("iframeEditor", this.configData.config);
                        this.loading = false;
                        script.onload = script.onreadystatechange = null;
                    };
                } else {
                    new DocsAPI.DocEditor("iframeEditor", this.configData.config);
                    this.loading = false;
                }
            },

        },
        destroyed() {

        },
        watch: {

        },
        filters: {},
    };
</script>

<style scoped lang="less" >

    .file-content{
        padding-top: 10px;
        .area-title{
            font-size: 24px;
            color: #000;
            height: 40px;
            line-height: 40px;
            font-weight: 700;
            color: #6e747d;
            text-align: center;
            margin: 0 auto;
            background: #FFFFFF;
        }
        width: 90vw;
        margin: 0 auto;
        .area{
            min-height: calc(100vh - 60px);
            background: #FFFFFF;
            width: 100%;
            margin: 0 auto;
            padding: 10px;
            /*border-radius: 5px;*/
            overflow: hidden;
            .form{
                height: calc(100vh - 80px);
            }

        }
    }



</style>
